interface BankInfoAnalyticAccountCellDelegate
{
    analyticAccountCellDidTapDropdown(cell:BankInfoAnalyticAccountCell, entry:BankEntry): void;
    analyticAccountCellDidApplySuggestion(cell:BankInfoAnalyticAccountCell, entry:BankEntry, account:AnalyticAccount): void;
}

// The analytic account of the movement. While it has none, the suggested one sits at the right of
// the title and is applied with a click.
class BankInfoAnalyticAccountCell extends UITableViewCell
{
    delegate:BankInfoAnalyticAccountCellDelegate = null;

    private dropdownButton:MUIButton = null;
    private suggestionLabel:MUILabel = null;
    private applySuggestionButton:MUIButton = null;

    private _entry:BankEntry = null;
    private _suggestion:AnalyticAccountSuggestion = null;

    awakeFromHTML() {
        this.dropdownButton = MUIOutlet(this, "analytic-account-dd", "MUIButton");
        this.dropdownButton.setAction(this, function(this:BankInfoAnalyticAccountCell) {
            if (this.delegate != null) {
                this.delegate.analyticAccountCellDidTapDropdown(this, this._entry);
            }
        });

        this.suggestionLabel = MUIOutlet(this, "suggestion-lbl", "MUILabel");
        this.applySuggestionButton = MUIOutlet(this, "apply-suggestion-btn", "MUIButton");
        this.applySuggestionButton.setAction(this, function(this:BankInfoAnalyticAccountCell) {
            if (this.delegate != null && this._suggestion != null) {
                this.delegate.analyticAccountCellDidApplySuggestion(this, this._entry, this._suggestion.account);
            }
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setEntry(entry:BankEntry, suggestion:AnalyticAccountSuggestion) {
        this._entry = entry;
        this._suggestion = suggestion;

        this.dropdownButton.title = (entry != null ? BankMovementState.analyticAccountTitle(entry) : null) ?? MIOLocalizeString("NO_ANALYTIC_ACCOUNT", "No analytic account");

        if (suggestion != null) {
            this.suggestionLabel.text = suggestion.account.title;
            this.applySuggestionButton.layer.title = MIOLocalizeString("APPLY_SUGGESTION", "Apply suggestion") + ": " + suggestion.account.title + " (" + suggestion.matches + ")";
        }
        this.applySuggestionButton.hidden = suggestion == null;
    }
}
